import { Button, dialog } from "nq-component";
import CardView from "../../../../components/common/CardView";
import {
  convertTo12Hour,
  FloatingForm,
  formatDate,
} from "../../../../components/common/Converter";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import { useState } from "react";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import InputFactory from "../../../../components/InputFactory";
import emailBody from "./EmailBody";
import { restUseCase } from "../../../../usecases/rest";

export function UpdateObjectStatus({
  handleFloatingClose,
  allEmployee,
  selected,
  showError,
  refetchData,
}) {
  console.log("selected", selected);
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const fields = ["region", "office", "division", "section", "unit", "cluster"];

  console.log("chery stats", status);
  const handleStatusChange = (value) => {
    console.log("show", value);
    setStatus(value);
  };

  const handleSubmitStatus = async () => {
    if (status === "Hired") {
      const biometricID = await findObjectUseCase().execute("employees", {
        keys: ["id", "biometricId"],
        limit: 1,
        sort: { createdAt: -1 },
      });

      const matchedEmails = selected
        .filter((select) =>
          allEmployee.some((emp) => emp.email === select.email),
        )
        .map((s) => s.email);

      if (matchedEmails.length > 0) {
        showError(
          `Email already exists: ${matchedEmails.join(
            ", ",
          )},\n Please unselect to proceed.`,
        );
        handleFloatingClose("isStatusClicked");
        return;
      }

      const excludeEmployeeData = [
        "civilCareer",
        "otherCivilCareer",
        "civilExaminationFrom",
        "civilExaminationTo",
        "civilLicense",
        "civilPlace",
        "civilRating",
        "civilValidity",
        "educationDegree",
        "educationFrom",
        "educationHighest",
        "educationHonors",
        "educationLevel",
        "educationSchool",
        "educationTo",
        "educationYear",
        "learningConducted",
        "learningFrom",
        "learningHours",
        "learningTitle",
        "learningTo",
        "learningType",
        "leavePeriodFrom",
        "leavePeriodTo",
        "membership",
        "reference",
        "referenceAddress",
        "referenceName",
        "referenceTel",
        "specialSkills",
        "status",
        "updatedAt",
        "voluntaryFrom",
        "voluntaryHours",
        "voluntaryOrganization",
        "positionTitle",
        "voluntaryPosition",
        "voluntaryTo",
        "location",
        "examDate",
        "recognition",
        //file attachements
        "letterOfIntent",
        "idPicture",
        "placeOfAssignment",
        "placeOfOrigin",
      ];

      for (const object of selected) {
        if (object.status !== "Hired" && object.status !== "Rejected") {
          // const filterObject = (object, includeKeys) =>
          //   Object.keys(object)
          //     .filter((key) => includeKeys.includes(key))
          //     .reduce((newObj, key) => {
          //       newObj[key] = object[key];
          //       return newObj;
          //     }, {});

          const filterObject = (obj, includeKeys, additionalFields = {}) =>
            Object.keys(obj)
              .filter((key) => includeKeys.includes(key))
              .reduce((newObj, key) => {
                newObj[key] = obj[key];
                return newObj;
              }, additionalFields);

          const employeeObject = filterObject(
            object,
            Object.keys(object).filter(
              (key) => !excludeEmployeeData.includes(key),
            ),
          );
          const employeeData = {
            ...employeeObject,
            position: object.positionTitle,
            region: object?.positionTitle?.region,
            office: object?.positionTitle?.office,
            division: object?.positionTitle?.division,
            section: object?.positionTitle?.section,
            unit: object?.positionTitle?.unit,
            cluster: object?.positionTitle?.cluster,
            salaryCode: object?.positionTitle?.salaryPointer?.salaryCode,
            othersFile: [
              ...(object?.letterOfIntent?.length > 0
                ? object.letterOfIntent
                : []),
              ...(object?.idPicture?.length > 0 ? object.idPicture : []),
            ],
            biometricId: biometricID[0].biometricId + 1,
          };

          const educationData = filterObject(object, [
            "educationDegree",
            "educationFrom",
            "educationHighest",
            "educationHonors",
            "educationLevel",
            "educationSchool",
            "educationTo",
            "educationYear",
            "email",
          ]);

          const civilData = filterObject(object, [
            "civilCareer",
            "otherCivilCareer",
            "civilExaminationFrom",
            "civilExaminationTo",
            "civilLicense",
            "civilPlace",
            "civilRating",
            "civilValidity",
            "email",
          ]);

          const voluntaryData = filterObject(object, [
            "voluntaryFrom",
            "voluntaryHours",
            "voluntaryOrganization",
            "voluntaryPosition",
            "voluntaryTo",
            "email",
          ]);

          const learningData = filterObject(object, [
            "learningConducted",
            "learningFrom",
            "learningHours",
            "learningTitle",
            "learningTo",
            "learningType",
            "email",
          ]);

          const otherData = filterObject(object, [
            "specialSkills",
            "recognition",
            "membership",
            "email",
          ]);

          const referenceData = filterObject(object, [
            "referenceAddress",
            "referenceName",
            "referenceTel",
            "email",
          ]);
          const referenceData2 = filterObject(object, ["email"], {
            referenceName: object.referenceName2,
            referenceAddress: object.referenceAddress2,
            referenceTel: object.referenceTel2,
          });
          const referenceData3 = filterObject(object, ["email"], {
            referenceName: object.referenceName3,
            referenceAddress: object.referenceAddress3,
            referenceTel: object.referenceTel3,
          });

          object.status = status;

          // console.log("employeeData: ", employeeData);
          // console.log("OBBB: ", employeeData);
          // console.log("education: ", educationData);
          // console.log("civil: ", civilData);
          // console.log("VOluntary: ", voluntaryData);
          // console.log("Learning: ", learningData);
          // console.log("Other: ", otherData);
          // console.log("Reference: ", referenceData);
          // console.log("Reference2: ", referenceData2);
          // console.log("Reference3: ", referenceData3);
          // return;
          delete employeeData.publication;
          delete employeeData.typeOfApplicant;
          delete employeeData.typeOfApplication;
          delete employeeData.referenceName2;
          delete employeeData.referenceAddress2;
          delete employeeData.referenceTel2;
          delete employeeData.referenceName3;
          delete employeeData.referenceAddress3;
          delete employeeData.referenceTel3;
          delete employeeData.groupId;
          // console.log("employeeData: ", employeeData);
          try {
            refetchData();
            const response = await upsertUseCase().execute(
              "employees",
              employeeData,
            );

            await Promise.all([
              upsertUseCase().execute("educational_background", {
                ...educationData,
                empID: response.id,
              }),
              upsertUseCase().execute("service_eligibility", {
                ...civilData,
                empID: response.id,
              }),
              voluntaryData?.voluntaryOrganization &&
                upsertUseCase().execute("voluntary_work", {
                  ...voluntaryData,
                  empID: response.id,
                }),
              learningData?.learningTitle &&
                upsertUseCase().execute("learning_development", {
                  ...learningData,
                  empID: response.id,
                }),
              otherData?.specialSkills &&
                upsertUseCase().execute("other_information", {
                  ...otherData,
                  empID: response.id,
                }),
              upsertUseCase().execute("reference_table", {
                ...referenceData,
                empID: response.id,
              }),
              referenceData2?.referenceName &&
                upsertUseCase().execute("reference_table", {
                  ...referenceData2,
                  empID: response.id,
                }),
              referenceData3?.referenceName &&
                upsertUseCase().execute("reference_table", {
                  ...referenceData3,
                  empID: response.id,
                }),
              upsertUseCase().execute("job_applicants", object),
            ]);
            refetchData();
            handleFloatingClose("isStatusClicked");
            return;
          } catch (e) {
            console.error(e);
            showError(e?.message);
          }
        }
      }
      refetchData();
      handleFloatingClose("isStatusClicked");
      return;
    }
    if (status === "Rejected") {
      dialog.fire({
        html: (
          <div className="p-2">
            <div className="row">
              <h4>Submit Request Confirmation</h4>
              <hr />
              <p style={{ fontSize: "13px", padding: "1rem" }}>
                Click confirm to proceed.
              </p>
              <hr />
            </div>

            <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
              <Button
                className="btn btn-light fs-sm"
                onClick={() => dialog.close()}
              >
                Cancel
              </Button>
              <Button
                className="btn btn-primary"
                onClick={() => confirmRejected()}
              >
                Confirm
              </Button>
            </div>
          </div>
        ),
        footer: false,
      });
    } else {
      for (const object of selected) {
        if (object.status !== "Hired" && object.status !== "Rejected") {
          object.status = status;
          await upsertUseCase().execute("job_applicants", object);
        }
      }
      refetchData();
      handleFloatingClose("isStatusClicked");
    }
  };

  const confirmRejected = async () => {
    selected.forEach(async (item) => {
      if (item.status !== "Rejected" && item.status !== "Hired") {
        dialog.close();
        setIsLoading(true);
        const body = emailBody(item, status, item);
        console.log("BODY: ", body);
        const method = "POST";
        const path = "/send-email/e10b30c4-e2bf-4e58-9441-df2a62c0683c";
        const obj = {
          to: item?.email,
          body,
          subject: `Position: ${item?.positionTitle?.position_title}`,
        };

        console.log("OBJECT: ", obj);

        try {
          const response = await restUseCase().execute(method, path, {
            body: obj,
          });
          console.log("RESPONSE: ", response);
          item.status = status;
          await upsertUseCase().execute("job_applicants", item);
          refetchData();
        } catch (e) {
          console.error(e);
        } finally {
          setTimeout(() => {
            const interval = setInterval(() => {
              setIsLoading(false);
              handleFloatingClose("isStatusClicked");
              clearInterval(interval); // Optional: Clears the interval after it's executed once if that's your intent
            });
          }, isLoading);
        }
      } else {
        dialog.close();
        handleFloatingClose("isStatusClicked");
        refetchData();
      }
    });
  };

  return (
    <FloatingForm width="30rem">
      {isLoading ? (
        <div className="d-flex align-items-center justify-content-center p-5">
          <img
            src="/email.gif"
            alt="Loading"
            width="100%"
            height="100%"
            style={{ borderRadius: "20%" }}
          />
        </div>
      ) : (
        <CardView style={{ padding: 0 }}>
          <h4 className="fs-6 fw-bold pt-3 ps-3">Update Applicant Status</h4>
          <hr />
          <div className="row p-4">
            <label className="pb-2">Status: </label>
            <SearchSelect
              required={true}
              value={status}
              onChange={(val) => handleStatusChange(val)}
              options={[
                "For Interview",
                "For Exam",
                "Hired",
                "Rejected",
                "Promoted",
              ].map((data) => {
                return {
                  label: data,
                  value: data,
                };
              })}
            />
          </div>
          <hr />
          <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => handleFloatingClose("isStatusClicked")}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => handleSubmitStatus()}
            >
              Submit
            </Button>
          </div>
        </CardView>
      )}
    </FloatingForm>
  );
}

// setting scehdule
export function SetApplicantSchedule({
  handleFloatingClose,
  object,
  showSuccess,
  refetchData,
}) {
  const [scheduleType, setScheduleType] = useState("");
  const [scheduleDate, setScheudleDate] = useState("");
  const [timeFrom, setScheduleTimeFrom] = useState("");
  const [timeTo, setScheduleTimeTo] = useState("");
  const [deadline, setDeadline] = useState("");
  const [deadlineTime, setDeadlineTime] = useState("");
  const [zoomlink, setZoomlink] = useState("");
  const [passcode, setPasscode] = useState("");
  const [venue, setVenue] = useState("");
  const [nameOne, setNameOne] = useState("");
  const [nameTwo, setNameTwo] = useState("");
  const [nameThree, setNameThree] = useState("");
  const [nameFour, setNameFour] = useState("");
  const [descriptionOne, setDescriptionOne] = useState("");
  const [descriptionTwo, setDescriptionTwo] = useState("");
  const [descriptionThree, setDescriptionThree] = useState("");
  const [descriptionFour, setDescriptionFour] = useState("");
  const [location, setLocation] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleFormChange = (filed, value) => {
    console.log("field: ", filed, " value: ", value);
    filed(value);
  };

  const handleSubmitShedule = async () => {
    const options = {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
    };

    if (!Array.isArray(object) || object.length === 0) {
      console.error("Error: object is undefined or empty");
      return;
    }

    console.log("scheduleType", scheduleType);

    for (let obj of object) {
      obj.scheduleType = scheduleType;
      obj.scheduleDate = new Date(scheduleDate).toLocaleDateString(
        "en-US",
        options,
      );
      obj.timeFrom = convertTo12Hour(timeFrom);
      obj.timeTo = convertTo12Hour(timeTo);
      obj.zoomLink = zoomlink;
      obj.passcode = passcode;
      obj.deadline = formatDate(deadline);
      obj.deadlineTime = convertTo12Hour(deadlineTime);
      obj.nameOne = nameOne;
      obj.nameTwo = nameTwo;
      obj.nameThree = nameThree;
      obj.nameFour = nameFour;
      obj.descriptionOne = descriptionOne;
      obj.descriptionTwo = descriptionTwo;
      obj.descriptionThree = descriptionThree;
      obj.descriptionFour = descriptionFour;
      obj.location = location;
      obj.venue = venue;

      try {
        const applicant = await findObjectUseCase().execute("job_applicants", {
          where: { id: obj.id },
        });

        if (!applicant || applicant.length === 0) {
          console.warn(`Applicant with ID ${obj.id} not found.`);
          continue;
        }

        const applicantObj = applicant[0];
        await emailIntegration(obj, scheduleType, applicantObj);
      } catch (error) {
        console.error(`Error processing applicant with ID ${obj.id}:`, error);
      }
    }
  };

  const emailIntegration = async (object, scheduleType, applicantObj) => {
    setIsLoading(true);
    const body = emailBody(object, scheduleType, applicantObj);
    console.log("BODY: ", body);
    const method = "POST";
    const path = "/send-email/e10b30c4-e2bf-4e58-9441-df2a62c0683c";
    const obj = {
      to: object?.email,
      body,
      // link: this.view.state.linkUrl,
      // applicant: `${object?.firstName} ${object?.middleName} ${object?.surname}`,
      subject: `Position: ${object?.positionTitle?.position_title}`,
    };

    console.log("OBJECT: ", obj);

    try {
      const response = await restUseCase().execute(method, path, {
        body: obj,
      });
      refetchData();
      console.log("RESPONSE: ", response);
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        const interval = setInterval(() => {
          setIsLoading(false);
          handleFloatingClose("isScheduleClicked");
          showSuccess("Email Successfully send!");
          clearInterval(interval); // Optional: Clears the interval after it's executed once if that's your intent
        });
      }, isLoading);
    }
  };

  return (
    <FloatingForm width="35rem">
      {isLoading ? (
        <div className="d-flex align-items-center justify-content-center p-5">
          <img
            src="/email.gif"
            alt="Loading"
            width="100%"
            height="100%"
            style={{ borderRadius: "20%" }}
          />
        </div>
      ) : (
        <CardView style={{ padding: 0 }}>
          <h4 className="fs-6 fw-bold pt-3 ps-3">Schedule</h4>
          <hr />
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmitShedule();
            }}
          >
            <div className="row p-4">
              {/* Schedule Type Select */}
              <div className="col-lg-6 mb-4">
                <label className="mb-2 fs-6">
                  Type:{" "}
                  <span className="text-danger">
                    {scheduleType === "Online Exam" ? "" : "*"}
                  </span>
                </label>
                <SearchSelect
                  required={true}
                  value={scheduleType}
                  onChange={(val) => handleFormChange(setScheduleType, val)}
                  // onChange={(val) => setScheduleType(val)}
                  options={["Online Interview", "Online Exam", "F2F Exam"].map(
                    (data) => ({ label: data, value: data }),
                  )}
                />
              </div>

              {/* Date, From, To Input */}
              {["Date", "From", "To"].map((label) => (
                <div className="col-lg-6" key={label}>
                  <label className="mb-2 fs-6">
                    {label}:{" "}
                    <span className="text-danger">
                      {scheduleType === "Online Exam" ? "" : "*"}
                    </span>
                  </label>
                  <InputFactory
                    required={scheduleType === "Online Exam" ? false : true}
                    type={label === "Date" ? "Date" : "time"}
                    onChange={(val) =>
                      handleFormChange(
                        {
                          Date: setScheudleDate,
                          From: setScheduleTimeFrom,
                          To: setScheduleTimeTo,
                        }[label],
                        val,
                      )
                    }
                  />
                </div>
              ))}

              {/* Deadline and Time for Online Interview */}
              {scheduleType === "Online Interview" &&
                ["Dedline", "Time"].map((label) => (
                  <div className="col-lg-6" key={label}>
                    <label className="mb-2 fs-6">
                      {label}: <span className="text-danger">*</span>
                    </label>
                    <InputFactory
                      required
                      type={label === "Dedline" ? "Date" : "time"}
                      onChange={(val) =>
                        handleFormChange(
                          { Dedline: setDeadline, Time: setDeadlineTime }[
                            label
                          ],
                          val,
                        )
                      }
                    />
                  </div>
                ))}

              {/* Zoom Link and Passcode for Online Interview/Exam */}
              {(scheduleType === "Online Interview" ||
                scheduleType === "Online Exam") &&
                ["Zoom Link", "Passcode"].map((label) => (
                  <div className="col-lg-6 mb-4" key={label}>
                    <label className="mb-2 fs-6">
                      {label}:{" "}
                      <span className="text-danger">
                        {scheduleType === "Online Exam" ? "" : "*"}
                      </span>
                    </label>
                    <InputFactory
                      required={scheduleType === "Online Exam" ? false : true}
                      type="String"
                      onChange={(val) =>
                        handleFormChange(
                          { "Zoom Link": setZoomlink, Passcode: setPasscode }[
                            label
                          ],
                          val,
                        )
                      }
                    />
                  </div>
                ))}

              {/* Location and Venue for F2F Exam */}
              {scheduleType === "F2F Exam" &&
                ["Location", "Venue"].map((label) => (
                  <div className="col-lg-6" key={label}>
                    <label className="mb-2 fs-6">
                      {label}: <span className="text-danger">*</span>
                    </label>
                    {label === "Venue" ? (
                      <InputFactory
                        required
                        type="String"
                        onChange={(val) =>
                          handleFormChange(
                            { Location: setLocation, Venue: setVenue }[label],
                            val,
                          )
                        }
                      />
                    ) : (
                      <SearchSelect
                        required={true}
                        value={location}
                        onChange={(val) => handleFormChange(setLocation, val)}
                        options={["Luzon", "Visayas", "Mindanao"].map(
                          (data) => ({ label: data, value: data }),
                        )}
                      />
                    )}
                  </div>
                ))}

              {/* name and description*/}
              {scheduleType === "Online Exam" &&
                [
                  "Name 1",
                  "Description 1",
                  "Name 2",
                  "Description 2",
                  "Name 3",
                  "Description 3",
                  "Name 4",
                  "Description 4",
                ].map((label, index) => (
                  <div className="col-lg-6 mb-4" key={index}>
                    <label className="mb-2 fs-6">
                      {label.split(" ")[0]}:{" "}
                      <span className="text-danger">
                        {scheduleType === "Online Exam" ? "" : "*"}
                      </span>
                    </label>
                    <InputFactory
                      required={scheduleType === "Online Exam" ? false : true}
                      type="String"
                      onChange={(val) =>
                        handleFormChange(
                          {
                            "Name 1": setNameOne,
                            "Description 1": setDescriptionOne,
                            "Name 2": setNameTwo, // Second pair of state handlers
                            "Description 2": setDescriptionTwo,
                            "Name 3": setNameThree,
                            "Description 3": setDescriptionThree,
                            "Name 4": setNameFour,
                            "Description 4": setDescriptionFour,
                          }[label],
                          val,
                        )
                      }
                    />
                  </div>
                ))}
            </div>

            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
              <Button
                className="btn btn-light fs-sm"
                onClick={() => handleFloatingClose("isScheduleClicked")}
                type="button"
              >
                Cancel
              </Button>
              <Button className="btn btn-primary" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </CardView>
      )}
    </FloatingForm>
  );
}
